import { useState } from 'react';
import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_KEY || 'sffs-secret-2025';

//This defines a secret key that will be used for encryption and decryption. It's important to keep this
// key secure to ensure the security of your data.


const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};


// This function takes data as input, converts it to a JSON string, encrypts it using the AES 
// encryption algorithm from CryptoJS, and returns the encrypted ciphertext as a string.



const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};
;
// This function takes ciphertext as input, decrypts it using the AES decryption 
// algorithm from CryptoJS, converts the decrypted bytes to a UTF-8 string, and parses it as JSON to retrieve the original data.



export const setItemWithExpiry = (key, value, expiryInMinutes) => {
  const now = new Date();
  const item = {
    value: encryptData(value),
    expiry: now.getTime() + expiryInMinutes * 60000,
  };
  console.log(`Setting item ${key} with expiry:`, item);
  localStorage.setItem(key, JSON.stringify(item));
};




// This function takes key, value, and expiryInMinutes as inputs. It encrypts the value using
//  the encryptData function, calculates the expiry time in milliseconds, and stores the encrypted value
//   along with the expiry time in the localStorage.


export const getItemWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    console.log(`Item ${key} not found in localStorage.`);
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    console.log(`Item ${key} expired.`);
    localStorage.removeItem(key);
    return null;
  }
  console.log(`Retrieving item ${key}:`, item);
  return JSON.parse(decryptData(item.value));
};

// This function takes key as input, retrieves the item from localStorage, checks if it has expired, 
// decrypts the value using the decryptData function, and returns the original data.
//  If the key is 'isAuthenticated' or 'userRole', it returns the value without decryption.


const UseSecureLocalStorage = (key, initialValue, expiryInMinutes) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = getItemWithExpiry(key);
      return item ? item : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      setItemWithExpiry(key, value, expiryInMinutes);
      setStoredValue(value);
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue];
};

// This custom hook takes key, initialValue, and expiryInMinutes as inputs.
//  It initializes the state with the value retrieved from localStorage,
//  and provides a setValue function to update the state and store the new value in localStorage.
//   It returns an array containing the 


export default UseSecureLocalStorage;
